import { useId } from 'react'

// The mark (public/favicon.svg, drawn inline): two points and the thread
// between them on IDYL's black, the thread lit from white (your machine) to
// periwinkle (their browser). Decorative; the wordmark beside it is the name.
export function Mark() {
  const id = useId()
  return (
    <svg className="mark" viewBox="0 0 64 64" aria-hidden="true">
      <defs>
        <linearGradient id={`${id}t`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#1A1B21" />
          <stop offset="1" stopColor="#08080A" />
        </linearGradient>
        <linearGradient id={`${id}l`} x1="20" y1="44" x2="44" y2="20" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#F5F5F5" />
          <stop offset="1" stopColor="#B5C6F0" />
        </linearGradient>
        <radialGradient id={`${id}g`}>
          <stop offset="0" stopColor="#B5C6F0" stopOpacity=".45" />
          <stop offset="1" stopColor="#B5C6F0" stopOpacity="0" />
        </radialGradient>
      </defs>
      <rect x=".75" y=".75" width="62.5" height="62.5" rx="15.25" fill={`url(#${id}t)`} stroke="#34353D" strokeWidth="1.5" />
      <circle cx="44" cy="20" r="17" fill={`url(#${id}g)`} />
      <path d="M20 44 44 20" stroke={`url(#${id}l)`} strokeWidth="4" strokeLinecap="round" />
      <circle cx="20" cy="44" r="7" fill="#F5F5F5" />
      <circle cx="44" cy="20" r="7" fill="#B5C6F0" />
    </svg>
  )
}
